import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
	container: {
		marginTop: '2rem',
		border: '.1rem solid rgba(0, 0, 0, 0.38)',
		maxHeight: '60rem',
		overflow: 'auto',
		borderRadius: '0.4rem',
		padding: '0.4rem 1.7rem 1.7rem 1.7rem'
	},
	backButton: {
		marginLeft: '1rem'
	},
	headerText: {
		flexGrow: 1,
		display: 'flex',
		alignItems: 'center',
		color: '#fc4b58',
		fontWeight: 'bold'
	},
	changeLog: {
		marginTop: '2.5rem',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		borderColor: '#fc4b58',
		padding: '1.6rem',
		maxHeight: '50rem',
		overflow: 'auto'
	},
	featureTitle: {
		textTransform: 'capitalize',
		padding: '0.4rem',
		color: 'teal'
	},
	updateTypeBox: {
		flex: 1,
		maxHeight: '30rem',
		padding: '1rem',
		overflow: 'auto',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		cursor: 'pointer'
	},
	updateTypeText: {
		position: 'sticky',
		top: '0rem',
		backgroundColor: 'white',
		width: '100%',
		zIndex: '1000',
		display: 'inline-block',
		paddingBottom: '0.5rem'
	}
}));
